// Status-Abzeichen — EINE Komponente für alle Verwaltungsseiten.
//
// ⚠️ Vorher hatte jede Seite ihre eigene `getStatusBadge`-Funktion. Drei Kopien, und die
// Beschriftungen waren bereits auseinandergelaufen: Audio und Video sagten „Veröffentlicht",
// die Inhalte-Seite „Published". Dieselbe Krankheit wie bei den Themen-Listen und den
// Tabellenköpfen — es gibt geteilte Bausteine, nur benutzt sie niemand.
//
// Nimmt einen rohen Status-String, NICHT `ContentStatus`: die Listen reichen den Wert durch, wie
// die Antwort ihn liefert. Genau darum geht es im Fall darunter — kommt ein Wert herein, den das
// CMS-Enum nicht kennt, soll er sichtbar werden, statt am Typ zu scheitern oder still zu fehlen.
import React from 'react';
import { STATUS_ANZEIGE } from '../../types';

interface StatusBadgeProps {
  status: string | undefined | null;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  if (!status) return null;
  const eintrag = STATUS_ANZEIGE[status];
  // Unbekannter Status: roher Wert statt leerer Fläche. Sichtbar falsch schlägt unsichtbar weg —
  // so fällt auf, wenn das Backend einen Wert einführt, den das CMS noch nicht kennt.
  if (!eintrag) return <span className="badge badge-secondary">{status}</span>;
  return <span className={`badge ${eintrag.ton}`}>{eintrag.text}</span>;
};
